import { render, staticRenderFns } from "./FooterDesktop.vue?vue&type=template&id=7e828a0e&scoped=true&"
import script from "./FooterDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FooterDesktop.vue?vue&type=style&index=0&id=7e828a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e828a0e",
  null
  
)

export default component.exports